import * as fromWordpress from './wordpress/wordpress.reducer';
import * as fromFixedPages from './fixed-pages/fixedPages.reducer';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { WordpressEffects } from './wordpress/wordpress.effects';
import { FixedPagesEffects } from './fixed-pages/fixedPages.effects';
import { storeFixedPagesKey } from '@streamamg/components-lib';
import * as fromFixtures from './fixtures/fixtures.reducer';
import { FixturesEffects } from './fixtures/fixtures.effects';
import * as fromTeams from './teams/teams.reducer';
import { TeamsEffects } from './teams/teams.effects';
export interface StoreState {
  status?: {
    ready?: boolean;
    loading?: boolean;
    error?: any
  }
}

export interface AppState {
  [fromWordpress.featureKey]: fromWordpress.State;
  [storeFixedPagesKey]: fromFixedPages.State;
  [fromFixtures.featureKey]: fromFixtures.State;
  [fromTeams.featureKey]: fromTeams.State;
}

export const reducers: ActionReducerMap<AppState> = {
  [fromWordpress.featureKey]: fromWordpress.reducer,
  [storeFixedPagesKey]: fromFixedPages.reducer,
  [fromFixtures.featureKey]: fromFixtures.reducer,
  [fromTeams.featureKey]: fromTeams.reducer,
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];

export const effects = [
  WordpressEffects,
  FixedPagesEffects,
  FixturesEffects,
  TeamsEffects,
];
